export default{
    url: "https://adaorder.dctechonline.cn/api"
    //url: "http://47.102.155.212:8031/api"
}


// WEBPACK FOOTER //
// ./src/util/config.js